let $ = require("jquery");
import _ from "underscore";
import render from "../../../utilities/render";
import {setElementsFromScope} from '../../../utilities/selectorHelpers';
import {createPreventDefault} from '../../../utilities/general';
import { SUCCESS_MODAL_TIMEOUT } from "../../../constants";
import SubmitModalFlow from "../../../components/SubmitModalFlow/SubmitModalFlow";

const elementsPageMap = {
  headerBtnsContainer: ".team-details-header-btns",
  deactivateMemberBtn:'.deactivate-member-btn',
  activateMemberBtn:'.activate-member-btn',
  teamMemberInactivePill:'.team-member-inactive-pill',
  teamMemberActivePill:'.team-member-active-pill',
  updatePassBtn:'.update-pass-btn',
  editTeamMember:'.edit-team-member'

  //teamBackButtonEditChecker: ".team-back-button-edit-checker"
};

const elementsModalsMap = {
  continueUpdatePassBtn:'.continue-update-pass-btn',
  cancelUpdatePassBtn:'.cancel-update-pass-btn',
  deactivateContinueBtn:'.deactivate-continue-btn',
  deactivateCancelBtn:'.deactivate-cancel-btn',
  activateContinueBtn:'.activate-continue-btn',
  activateCancelBtn:'.activate-cancel-btn',
  topModalCloseBtn:'.top-close-btn'
};


export default function DetailsBusinessLogic(mainEl) {
  const self = this;

  const elsPage = {};
  const elsModals = {};

  let updatePasswordModal;
  let deactivateModal;
  let activateModal;

  self.init = function() {
    generateModals();
    setElements();
    bindElements();
    setInitialState();
  };

  function setInitialState(){
    var status = elsPage.headerBtnsContainer.data("commerce-user-status");

    swapTeamStatusButton(status);
  };

  const submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();


  function generateModals() {
    updatePasswordModal = $(render(
      require("../../../sharedHtml/modal.html"),
      {
        title:'Update Password',
        footerBtns:'<a href="#" class="base-btn v2-btn purple-btn m-close-btn cancel-update-pass-btn">Cancel</a>\
        <a href="#" class="base-btn purple-btn continue-update-pass-btn">Continue</a>',
        body:require('./sharedHtml/updatePasswordModal.html'),
        modalDialogClass:'q-modal-dialog-500',
        modalTitleClass: "q-text-left",
        topCloseBtn:'true'
      }
    ));

    deactivateModal = $(render(
      require("../../../sharedHtml/modal.html"),
      {
        title:'Deactivate Team Member?',
        footerBtns:'<a href="#" class="base-btn v2-btn purple-btn m-close-btn deactivate-cancel-btn">Cancel</a>\
        <a href="#" class="base-btn purple-btn deactivate-continue-btn">Deactivate</a>',
        body:require('./sharedHtml/deactivateModal.html'),
        modalDialogClass:'q-modal-dialog-500',
        modalTitleClass: "q-text-left",
        topCloseBtn:'true'
      }
    ));

    activateModal = $(render(
      require("../../../sharedHtml/modal.html"),
      {
        title:'Activate Team Member?',
        footerBtns:'<a href="#" class="base-btn v2-btn purple-btn m-close-btn activate-cancel-btn">Cancel</a>\
        <a href="#" class="base-btn purple-btn activate-continue-btn">Activate</a>',
        body:require('./sharedHtml/activateModal.html'),
        modalDialogClass:'q-modal-dialog-500',
        modalTitleClass: "q-text-left",
        topCloseBtn:'true'
      }
    ));

    $("body").append(updatePasswordModal);
    $("body").append(deactivateModal);
    $("body").append(activateModal);
  }

  function setElements() {
    setElementsFromScope(elsPage, elementsPageMap, mainEl);
    setElementsFromScope(elsModals, elementsModalsMap, $("body"));
  }

  function bindElements() {
    //events from btns on page
    elsPage.deactivateMemberBtn.click(createPreventDefault(deactivateTeamMemberCallModal));
    elsPage.activateMemberBtn.click(createPreventDefault(activateTeamMemberCallModal));
    elsPage.updatePassBtn.click(createPreventDefault(updatePasswordCallModal));
    elsPage.editTeamMember.click(createPreventDefault(editTeamMemberCall));

    //events from btns in modals
    elsModals.continueUpdatePassBtn.click(createPreventDefault(continueUpdatePassBtn));
    elsModals.cancelUpdatePassBtn.click(createPreventDefault(cancelUpdatePassBtn));
    elsModals.deactivateContinueBtn.click(createPreventDefault(deactivateContinueBtn));
    elsModals.deactivateCancelBtn.click(createPreventDefault(deactivateCancelBtn));
    elsModals.activateContinueBtn.click(createPreventDefault(activateContinueBtn));
    elsModals.activateCancelBtn.click(createPreventDefault(activateCancelBtn));
    elsModals.topModalCloseBtn.click(createPreventDefault(topModalClose));

    //Why was edit checker on a details page?
    //EditChecker.bindCancelButton(elsPage.teamBackButtonEditChecker);    
  }

  function editTeamMemberCall(){
    $('#commerce-view-user-detail').submit();
  }

  function updatePasswordCallModal(){
    updatePasswordModal.modal("show");
  }

  function deactivateTeamMemberCallModal(){
    deactivateModal.modal("show");
  }

  function activateTeamMemberCallModal(){
    activateModal.modal("show");
  }


  function continueUpdatePassBtn(){
      $.ajax(
      {
          url: elsPage.updatePassBtn.data('url'),
          type: "POST",
          data: { userId: elsPage.updatePassBtn.data('userId')},
          beforeSend : function() {
            //$.blockUI({message : 'Updating Password, Please Wait..'});
            submitModalFlow.showLoadingModal();
          },
          complete : function() {
            //$.unblockUI();
          },
          success:function(data)
          {
            handleUpdatePassModalClose();
            submitModalFlow.showSuccessModal();
            setTimeout(function() {
              submitModalFlow.hideAllModals();
            }, SUCCESS_MODAL_TIMEOUT);

          }
      });
  }

  function deactivateContinueBtn(){
      $.ajax(
      {
          url: elsPage.deactivateMemberBtn.data('url'),
          type: "POST",
          data: { status: elsPage.deactivateMemberBtn.data('status'), userId: elsPage.deactivateMemberBtn.data('userId')},
          beforeSend : function() {
          	//$.blockUI({message : 'Changing Status, Please Wait..'});
            submitModalFlow.showLoadingModal();
          },
          complete : function() {
          	//$.unblockUI();
          },
          success:function(data)
          {
            submitModalFlow.showSuccessModal();
             setTimeout(function() {
              swapTeamStatus(elsPage.deactivateMemberBtn.data('status'));
              swapTeamStatusButton(elsPage.deactivateMemberBtn.data('status'));
              handleDeactivateModalClose();
              submitModalFlow.hideAllModals();
            }, SUCCESS_MODAL_TIMEOUT);
          }
      });
  }

  function activateContinueBtn(){
      $.ajax(
	    {
	        url: elsPage.activateMemberBtn.data('url'),
	        type: "POST",
	        data: { status: elsPage.activateMemberBtn.data('status'), userId: elsPage.activateMemberBtn.data('userId')},
	        beforeSend : function() {
	        	//$.blockUI({message : 'Changing Status, Please Wait..'});
             submitModalFlow.showLoadingModal();
	        },
	        complete : function() {
	        	//$.unblockUI();
	        },
	        success:function(data)
	        {
            submitModalFlow.showSuccessModal();
             setTimeout(function() {
              swapTeamStatus(elsPage.activateMemberBtn.data('status'));
              swapTeamStatusButton(elsPage.activateMemberBtn.data('status'));
              handleActivateModalClose();
              submitModalFlow.hideAllModals();
            }, SUCCESS_MODAL_TIMEOUT);
	        }
	    });
  }

  function cancelUpdatePassBtn(){
    handleUpdatePassModalClose();
  }

  function deactivateCancelBtn(){
    handleDeactivateModalClose();
  }

  function activateCancelBtn(){
    handleActivateModalClose();
  }

  function topModalClose(){
    handleUpdatePassModalClose();
    handleDeactivateModalClose();
    handleActivateModalClose();
  }


  function handleUpdatePassModalClose(){
    updatePasswordModal.modal("hide");
  }

  function handleDeactivateModalClose(){
    deactivateModal.modal("hide");
  }

  function handleActivateModalClose(){
    activateModal.modal("hide");
  }

  function swapTeamStatus(status){
      if(status) {
        $('#user-details-page-id .team-member-detail-status-pill').text('Active');
        $('#user-details-page-id .team-member-detail-status-pill').removeClass("q-pill-white-and-blue");
        $('#user-details-page-id .team-member-detail-status-pill').addClass("q-pill-blue");
      }
      else {
        $('#user-details-page-id .team-member-detail-status-pill').text('Inactive');
        $('#user-details-page-id .team-member-detail-status-pill').removeClass("q-pill-blue");
        $('#user-details-page-id .team-member-detail-status-pill').addClass("q-pill-white-and-blue");
      }
  }

  function swapTeamStatusButton(status){
    //if(status || status == "Activate") {
    if(status) {
      elsPage.deactivateMemberBtn.show();
      elsPage.activateMemberBtn.hide();
    }
    else {
      elsPage.deactivateMemberBtn.hide();
      elsPage.activateMemberBtn.show();
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/teamMembers/details/detailsBusinessLogic.js